import './community-loading-skeleton.css';

export default function CommunityLoadingSkeleton() {
  return (
    <div className="community-loading-skeleton" role="status" data-testid="community-loading-skeleton">
      <span className="sr-only">Loading community updates and photos…</span>
      <div className="community-skeleton-content" aria-hidden="true">
        {[0, 1, 2].map(index => (
          <div key={index}>
            <div className="community-skeleton-date" />
            <div className="community-skeleton-post">
              <div className="community-skeleton-author"><span /><i /></div>
              <div className="community-skeleton-lines"><span /><span /></div>
              {index !== 1 && <div className="community-skeleton-photo" />}
              <div className="community-skeleton-reactions"><span /><span /><span /></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
